import React, { Fragment, PureComponent } from 'react';
import Translator from 'translator';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { FHEContainer, FHEDivider } from 'data/components';
import { Toastr, tools } from 'data/common';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { SvgBox } from 'data/common/iconsvg';
import { TableHomeGenerators } from '../tables';
import { FormHome } from '../forms';
import ConsoProd from '../components/ConsoProd';
import { getHomeDetails, updateHomeDetails, updateConsoProd } from '../../../data/Homes/actions';
import getSelectors from '../selectors';

class HomeDetails extends PureComponent {
    static propTypes = {
        homeId: PropTypes.string.isRequired,
        getHomeDetails: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        updateConsoProd: PropTypes.func.isRequired,
        homeBoxMac: PropTypes.string.isRequired,
        isActive: PropTypes.bool.isRequired,
        updateConsoProdRight: PropTypes.bool.isRequired,
        updateHomeDetails: PropTypes.func.isRequired,
    };
    constructor(props) {
        super(props);
        this.state = {
            loading: props.isActive,
            needGetData: props.isActive,
            fetching: false,
            initialized: false,
            productModulesConsoProd: {},
            consoProd: { conso: {}, prod: {} },
            error: null,
        };
    }

    static getDerivedStateFromProps(props, state) {
        const { needGetData, loading, error, fetching, initialized } = state;
        const { isActive } = props;

        if (!initialized && isActive && !needGetData && !loading && !error && !fetching) return { needGetData: true, loading: true };
        return null;
    }

    componentDidMount() {
        const { isActive } = this.props;
        if (isActive) this.getHomeDetails();
    }

    componentDidUpdate() {
        const { isActive } = this.props;
        const { needGetData, fetching, error, initialized } = this.state;
        if (!initialized && isActive && needGetData && !fetching && !error) {
            this.getHomeDetails();
        }
    }
    getHomeDetails = () => {
        const { getHomeDetails, homeId } = this.props;
        this.state.needGetData = false;
        this.state.fetching = true;
        getHomeDetails(homeId)
            .then(data => {
                const productModulesConsoProd = data.consoProd.productModulesConsoProd;
                const consoProd = {
                    conso: this.formatProductModulesFromApi(data.consoProd, 'conso', productModulesConsoProd),
                    prod: this.formatProductModulesFromApi(data.consoProd, 'prod', productModulesConsoProd),
                };

                console.log(data, 'BLABKLZIGHOGnbqORGNIGRub');
                this.setState({
                    error: null,
                    loading: false,
                    needGetData: false,
                    fetching: false,
                    initialized: true,
                    productModulesConsoProd,
                    consoProd,
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({ error: message, loading: false, needGetData: false, fetching: false, initialized: false });
            });
    };
    formatProductModulesToSocket = productModules => {
        let res = {};
        Object.keys(productModules).map(moduleId => {
            const module = productModules[moduleId];
            res[`${module.productType}_${module.productIdentifier}_${module.lineCode}`] = {
                id: moduleId,
                product_type: module.productType,
                product_identifier: module.productIdentifier,
                product_code: module.lineCode,
                module_type: module.moduleType,
            };
        });
        return res;
    };
    formatProductModulesFromSocket = (productModules, type) => {
        const { productModulesConsoProd } = this.state;
        let res = {};
        let error = [];
        Object.keys(productModules).map(moduleId => {
            const module = productModules[moduleId];
            if (productModulesConsoProd[module.id]) res[module.id] = productModulesConsoProd[module.id];
            else {
                error.push(module.id);
            }
        });
        if (error.length > 0)
            Toastr.error(
                error.join(','),
                Translator.translate(
                    'generic.home.consoProd.modulesNotFound',
                    Translator.translate('generic.home.consoProd.devicesSelectionned', Translator.translate(`generic.home.consoProd.${type}.title`)),
                ),
            );
        return res;
    };
    formatProductModulesFromApi = (productModules, type, productModulesConsoProd) => {
        let res = {};
        let error = [];
        productModules[type].map(lineId => {
            if (productModulesConsoProd[lineId]) res[lineId] = productModulesConsoProd[lineId];
            else {
                error.push(lineId);
            }
        });
        if (error.length > 0)
            Toastr.error(
                error.join(','),
                Translator.translate(
                    'generic.home.consoProd.modulesNotFound',
                    Translator.translate('generic.home.consoProd.devicesSelectionned', Translator.translate(`generic.home.consoProd.${type}.title`)),
                ),
            );
        return res;
    };
    saveConsoProd = (type, product_modules) => {
        const { consoProd } = this.state;
        const { homeBoxMac, updateConsoProd } = this.props;
        return updateConsoProd(homeBoxMac, type, this.formatProductModulesToSocket(product_modules)).then(data => {
            const newConsoProd = { ...consoProd, [type]: this.formatProductModulesFromSocket(data.product_modules, type) };
            this.setState({ consoProd: newConsoProd });
            return newConsoProd;
        });
    };

    retryGetData = () => {
        this.setState({ error: null, loading: true, needGetData: true });
    };

    renderChildren = () => {
        const { productModulesConsoProd, consoProd } = this.state;
        const { isActive, updateHomeDetails, homeBoxMac, history, updateConsoProdRight } = this.props;

        return (
            <Fragment>
                <FormHome type="update" isActive={isActive} sendDataFunc={updateHomeDetails} />
                <FHEDivider title={Translator.translate('general.generators')} IconComponent={SvgBox} />
                <TableHomeGenerators />
                <FHEDivider title={Translator.translate('general.consoProd')} IconComponent={SvgBox} />
                {homeBoxMac.length > 0 ? (
                    <ConsoProd
                        productModulesConsoProd={productModulesConsoProd}
                        updateConsoProd={this.saveConsoProd}
                        updateConsoProdRight={updateConsoProdRight}
                        consoProd={consoProd}
                    />
                ) : (
                    <div>{Translator.translate('generic.home.consoProd.needBox', Translator.translate(`${history.environment}.centerName`))}</div>
                )}
            </Fragment>
        );
    };
    render() {
        const { error, loading } = this.state;

        return <FHEContainer hasNoClassContainer loading={loading} error={error} onClickFunc={this.retryGetData} onRender={this.renderChildren} />;
    }
}

function mapStateToProps(state, props) {
    const { history, match } = props;
    const homeId = match.params.homeId;
    const selectors = getSelectors(history.environment);
    const profile = selectors.getProfile(state);

    return {
        homeId,
        updateConsoProdRight: profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('homeUpdateConsoProd'),
        profile,
        homeBoxMac: selectors.getBoxByHomeId(state, homeId).getIn(['macAddress'], ''),
    };
}
export default withRouter(
    renderEnvComponent(
        'scenes/Home/sections/HomeDetails',
        connect(
            mapStateToProps,
            (dispatch, ownProps) =>
                bindActionCreators(
                    tools.mergePropsToAction(ownProps.history.environment, { getHomeDetails, updateHomeDetails, updateConsoProd }),
                    dispatch,
                ),
        )(HomeDetails),
    ),
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/sections/HomeDetails.js